import api from '../api/client'

const leiloeiroService = {
  // Listar leiloeiros por organizador
  getByOrganizador: async (organizadorId) => {
    const response = await api.get(`/organizadores/${organizadorId}/leiloeiros`)
    return response.data
  },

  // Criar leiloeiro
  create: async (organizadorId, leiloeiroData) => {
    const response = await api.post(`/organizadores/${organizadorId}/leiloeiros`, leiloeiroData)
    return response.data
  },

  // Atualizar leiloeiro
  update: async (organizadorId, leiloeiroId, leiloeiroData) => {
    const response = await api.put(`/organizadores/${organizadorId}/leiloeiros/${leiloeiroId}`, leiloeiroData)
    return response.data
  },

  // Excluir leiloeiro
  delete: async (organizadorId, leiloeiroId) => {
    const response = await api.delete(`/organizadores/${organizadorId}/leiloeiros/${leiloeiroId}`)
    return response.data
  },

  // ── Leiloeiros do Leilão (multi) ──────────────────────────────────────────

  listarDoLeilao: async (organizadorId, leilaoId) => {
    const response = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}/leiloeiros`)
    return response.data
  },

  adicionarAoLeilao: async (organizadorId, leilaoId, data) => {
    const response = await api.post(`/organizadores/${organizadorId}/leiloes/${leilaoId}/leiloeiros`, data)
    return response.data
  },

  atualizarNoLeilao: async (organizadorId, leilaoId, llId, data) => {
    const response = await api.put(`/organizadores/${organizadorId}/leiloes/${leilaoId}/leiloeiros/${llId}`, data)
    return response.data
  },

  removerDoLeilao: async (organizadorId, leilaoId, llId) => {
    await api.delete(`/organizadores/${organizadorId}/leiloes/${leilaoId}/leiloeiros/${llId}`)
  },
}

export default leiloeiroService
